export class Column {
  orderBy: number = 0;
  orderByCode: string = '+';
  name: string= '';
  fieldName: string= '';
  caption: string= '';
  datatype: number= 0;
  selected: boolean= false;
  include: string= '';
  visible: boolean= false;
}
